import { render, staticRenderFns } from "./GraficoSalas.vue?vue&type=template&id=78762d62&scoped=true"
import script from "./GraficoSalas.vue?vue&type=script&lang=js"
export * from "./GraficoSalas.vue?vue&type=script&lang=js"
import style0 from "./GraficoSalas.css?vue&type=style&index=0&id=78762d62&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78762d62",
  null
  
)

export default component.exports